import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Container, Row, Col, Form } from "react-bootstrap";
import DonutChart from "./DonutChart";
import searchIcon from "../../../../Assets/icons/searchicon.svg";
import "./Dashboard.scss";
import arrrowUP from "./../../../../Assets/icons/arrow-up 1.svg";
import arrroroRight from "./../../../../Assets/icons/arrowRight.svg";
import Lossicon from "./../../../../Assets/icons/LossIcon.svg";
import DashboardTable from "./DashboardTable";
import axiosInstance from "../../../services/api/API";
import AreaChart from "./AreaChart";
import Loader from "../../../customComponents/CustomLoader";

const LogisticsDashboard = () => {
  const [selectedMonth, setSelectedMonth] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [year, setYear] = useState(new Date().getFullYear());
  const token = localStorage.getItem("authToken");
  const [productData, setProductData] = useState([]);
  const [totalPO, setTotalPO] = useState();
  const [pendingPO, setPendingPO] = useState();
  const [completedPO, setCompletedPO] = useState();
  const [outofstockPO, setoutofstokPO] = useState();
  const [cancelPO, setCancelPO] = useState();
  const [userTypedd, setUserTypedd] = useState([]);
  const [dealerdd, setDealerdd] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedBusinessPartner, setSelectedBusinessPartner] = useState("");
  const [selectedDealer, setSelectedDealer] = useState("");
  const [LineChartData, setLineChartData] = useState([]);
  const [PieChartData, setPieChartData] = useState([]);
  const [totalPercentCount,setTotalPercentCount] = useState([])

  useEffect(() => {
    userTypedropdown();
  }, []);

  const userTypedropdown = async () => {
    try {
      const response = await axiosInstance.get("/bp-onboard/bplist", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = response.data.data.data;
      const userTypeOptions = data.map((user) => ({
        value: user.onboard_id,
        label: user.bp_name,
      }));
      setUserTypedd(userTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };

  const Dealerdropdown = async (id) => {
    try {
      const response = await axiosInstance.post(
        "/dealer/ddldealer",
        { business_partner_id: id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = response.data.data.data;
      const userTypeOptions = data.map((user) => ({
        value: user.ID,
        label: user.NAME,
      }));
      setDealerdd(userTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };

  const monthOptions = [
    { value: 1, label: "Jan" },
    { value: 2, label: "Feb" },
    { value: 3, label: "Mar" },
    { value: 4, label: "Apr" },
    { value: 5, label: "May" },
    { value: 6, label: "Jun" },
    { value: 7, label: "Jul" },
    { value: 8, label: "Aug" },
    { value: 9, label: "Sep" },
    { value: 10, label: "Oct" },
    { value: 11, label: "Nov" },
    { value: 12, label: "Dec" },
  ];

  const yearOptions = [...Array(5).keys()].map((i) => {
    const yearOption = new Date().getFullYear() - i;
    return {
      value: yearOption,
      label: yearOption,
    };
  });
  const customStyles = {
    control: (provided) => ({
      ...provided,
      border: "1px solid #7BD755",
      boxShadow: "none",
      borderRadius: "20px",
      backgroundColor: "#fff",
      color: "#7BD755",
      width: "200px",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "green",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#7BD755",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#7BD755",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "4px",
    }),
    menuList: (provided) => ({
      ...provided,
      padding: 0,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#7BD755" : provided.backgroundColor,
      color: state.isFocused ? "#fff" : "#000",
    }),
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };
  useEffect(() => {
    fetchDashboardData();
  }, [
    selectedBusinessPartner,
    year,
    selectedMonth,
    searchQuery,
    selectedDealer,
  ]);

  const fetchDashboardData = async () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
   
    try {
      setLoading(true);
      const response = await axiosInstance.post(
        `/logistic/dashboard-details`,
        {
          year: year || currentYear,
          month: selectedMonth?.value || null,
          business_partner_id: selectedBusinessPartner?.value,
          searchText: searchQuery,
          dealer_id: selectedDealer?.value,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const fetchedData = response?.data?.data?.tabledata;
      const fetchedGraphData = response?.data?.data?.graphdata;
      const fetchedPieData = response?.data?.data?.piedata;
      const fetchedDataCount = response?.data?.data?.countdetail[0];
      setTotalPercentCount(fetchedDataCount)
      console.log("totalPercentCount",fetchedDataCount?.total_po_percentage_change);
      
      setTotalPO(fetchedDataCount?.total_po);
      setCancelPO(fetchedDataCount?.cancel_po);
      setCompletedPO(fetchedDataCount?.completed_po);
      setoutofstokPO(fetchedDataCount?.outofstock);
      setPendingPO(fetchedDataCount?.pending_po);

      setProductData(fetchedData);
      setLineChartData(fetchedGraphData);
      setPieChartData(fetchedPieData);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false); // End loading
    }
  };
  useEffect(() => {
    const currentMonth = new Date().getMonth() + 1;
    setSelectedMonth(
      monthOptions.find((option) => option.value === currentMonth)
    );
  }, []);
  const handleBusinessPartnerChange = (selectedOption) => {
    console.log("selectedOption", selectedOption);

    setSelectedBusinessPartner(selectedOption);
    if (selectedOption) {
      Dealerdropdown(selectedOption.value);
    } else {
      setDealerdd([]);
    }
  };
  const handleDealerChange = (selectedOption) => {
    setSelectedDealer(selectedOption);
  };

  return (
    <div>
      {/* {loading ? ( 
      <Loader />
    ) : ( */}
      <div>
        <div className="dashboard-container">
          <div className="">
            <div className="filters-container">
              <p>Logistics / Dashboard</p>
              <div className="listsearchContainer">
                <h5>Dashboard</h5>
                <div className="searchinput-wrapper">
                  <input
                    type="text"
                    className="searchinput"
                    placeholder="Search..."
                    // value={searchQuery}
                    // onChange={handleSearchChange}
                  />
                  <img
                    src={searchIcon}
                    alt="Search"
                    className="searchinput-icon"
                  />
                </div>
                <div className="filtercontainer">
                  <Form.Group controlId="formMonth" className="filter-dropdown">
                    <Select
                      isClearable
                      styles={customStyles}
                      options={userTypedd}
                      onChange={handleBusinessPartnerChange}
                      placeholder="Select OEM"
                    />
                  </Form.Group>
                  <Form.Group controlId="formYear" className="filter-dropdown">
                    <Select
                      isClearable
                      styles={customStyles}
                      options={dealerdd}
                      onChange={handleDealerChange}
                      //value={yearOptions.find((option) => option?.value === year)}
                      //onChange={(option) => setYear(option?.value)}
                      placeholder="Select Dealer"
                    />
                  </Form.Group>
                </div>
              </div>
            </div>
            <div className="maincardssection mt-2 mb-2">
              <h6 className="mt-2">Select Period</h6>
              <div className="logcontainer">
                <div className="filtercontainer">
                  <Form.Group controlId="formMonth" className="filter-dropdown">
                    <Select
                      isClearable
                      styles={customStyles}
                      options={monthOptions}
                      value={selectedMonth}
                      onChange={(option) => setSelectedMonth(option)}
                      placeholder="Month"
                    />
                  </Form.Group>
                  <Form.Group controlId="formYear" className="filter-dropdown">
                    <Select
                      isClearable
                      styles={customStyles}
                      options={yearOptions}
                      value={yearOptions.find(
                        (option) => option?.value === year
                      )}
                      onChange={(option) => setYear(option?.value)}
                      placeholder="Year"
                    />
                  </Form.Group>
                </div>
                <div className="mainlogisticcardcontainer">
                  <div className="logisticcardscontainer">
                    <div className="TotalProductsMainContainer">
                      <div className="totalProductsContainer">
                        <span className="totalvalue">{totalPO}</span>
                        <div>
                          {totalPercentCount?.total_po_percentage_change>="0"?<img src={arrrowUP}></img>:<img src={Lossicon}></img>}
                          
                          <span className="totalpercent">{totalPercentCount?.total_po_percentage_change}%</span>
                        </div>
                      </div>
                      <span className="totalorders">
                        Total Purchase Orders <img src={arrroroRight}></img>
                      </span>
                    </div>

                    {/* <div style={{height:60,width:1,backgroundColor:'red'}}></div> */}
                  </div>
                  <div className="vertical-line"></div>
                  <div className="logisticcardscontainer">
                    <div className="TotalProductsMainContainer">
                      <div className="totalProductsContainer">
                        <span className="totalvalue">{completedPO}</span>
                        <div>
                          {totalPercentCount?.completed_po_percentage_change>="0"?<img src={arrrowUP}></img>:<img src={Lossicon}></img>}
                          
                          <span className="totalpercent">{totalPercentCount?.completed_po_percentage_change}%</span>
                        </div>
                      </div>
                      <span className="totalorders">
                        Total Completed Orders <img src={arrroroRight}></img>
                      </span>
                    </div>
                    {/* <div style={{height:60,width:1,backgroundColor:'red'}}></div> */}
                  </div>
                  <div className="vertical-line"></div>
                  <div className="logisticcardscontainer">
                    <div className="TotalProductsMainContainer">
                      <div className="totalProductsContainer">
                        <span className="totalvalue">{pendingPO}</span>
                        <div>
                          {totalPercentCount?.pending_po_percentage_change>="0"?<img src={arrrowUP}></img>:<img src={Lossicon}></img>}
                          
                          <span className="totalpercent">{totalPercentCount?.pending_po_percentage_change}%</span>
                        </div>
                      </div>
                      <span className="totalorders">
                        Total Pending Orders <img src={arrroroRight}></img>
                      </span>
                    </div>
                    {/* <div style={{height:60,width:1,backgroundColor:'red'}}></div> */}
                  </div>
                  <div className="vertical-line"></div>
                  <div className="logisticcardscontainer">
                    <div className="TotalProductsMainContainer">
                      <div className="totalProductsContainer">
                        <span className="totalvalue">{outofstockPO?outofstockPO:0}</span>
                        <div>
                          {totalPercentCount?.total_po_percentage_change>="0"?<img src={arrrowUP}></img>:<img src={Lossicon}></img>}
                          
                          <span className="totalpercent">{totalPercentCount?.total_po_percentage_change}%</span>
                        </div>
                      </div>
                      <span className="totalorders">
                        Total Out Of Stock <img src={arrroroRight}></img>
                      </span>
                    </div>
                    {/* <div style={{height:60,width:1,backgroundColor:'red'}}></div> */}
                  </div>
                  <div className="vertical-line"></div>
                  <div className="logisticcardscontainer">
                    <div className="TotalProductsMainContainer">
                      <div className="totalProductsContainer">
                        <span className="totalvalue">
                          {cancelPO ? cancelPO : 0}
                        </span>
                        <div>
                          {totalPercentCount?.total_po_percentage_change>="0"?<img src={arrrowUP}></img>:<img src={Lossicon}></img>}
                          
                          <span className="totalpercent">{totalPercentCount?.total_po_percentage_change}%</span>
                        </div>
                      </div>
                      <span className="totalorders">
                        Total Cancel Orders <img src={arrroroRight}></img>
                      </span>
                    </div>
                    {/* <div style={{height:60,width:1,backgroundColor:'red'}}></div> */}
                  </div>
                </div>
              </div>
            </div>

            <Container fluid className="fluidcontainer">
              <Row>
                <Col lg={6} className="charts-container">
                  {loading ? (
                    <Loader />
                  ) : (
                    <>
                      {LineChartData &&
                        Object.keys(LineChartData).length > 0 && (
                          <AreaChart graphdata={LineChartData} />
                        )}
                      <DonutChart PieChartData={PieChartData} />
                    </>
                  )}
                </Col>

                <Col lg={6} className="cards-container mt-4">
                  <h5 className="tabletitle">Top Purchased Product</h5>
                  <div className="searchinput-wrapper">
                    <input
                      type="text"
                      className="logisticsearch"
                      placeholder="Search by Product, Make, Model"
                      value={searchQuery}
                      onChange={handleSearchChange}
                    />
                    <img
                      src={searchIcon}
                      alt="Search"
                      className="searchinput-icon"
                    />
                  </div>
                  <DashboardTable productData={productData} />
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </div>
      {/* )} */}
    </div>
  );
};

export default LogisticsDashboard;
